export const AllEntityId = -1;
